import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import FormGroup from '../../FormGroup';

const propTypes = {
  values: PropTypes.shape({
    description: PropTypes.string,
  }),
  handleChange: PropTypes.func,
};

const FeedbackForm = ({ values, handleChange }) => {
  return (
    <Fragment>
      <FormGroup
        id="email_address"
        label="Email Address"
        onChange={handleChange}
        placeholder="Enter your email address here"
        value={values.email_address}
        required
      />
      <FormGroup
        id="description"
        label="description"
        type="textarea"
        placeholder="Please add your message here..."
        onChange={handleChange}
        value={values.description}
      />
    </Fragment>
  );
};

FeedbackForm.propTypes = propTypes;

export default FeedbackForm;
